import gsap from 'gsap';

export default function dropdowns() {
	document.querySelectorAll('.dropdowns__dropdown').forEach((dropdown) => {
		const title = dropdown.querySelector('.dropdowns__dropdown-title');
		const content = dropdown.querySelector('.dropdowns__dropdown-content');

		const isActive = dropdown.classList.contains(
			'dropdowns__dropdown--active'
		);

		gsap.set(content, {
			height: 'auto',
			display: isActive ? 'block' : 'none',
			overflow: 'hidden',
		});

		title.addEventListener('click', () => {
			const isVisible = gsap.getProperty(content, 'display') !== 'none';

			if (isVisible) {
				gsap.to(content, { height: 0, display: 'none', duration: 0.5 });
				dropdown.classList.remove('dropdowns__dropdown--active');
			} else {
				gsap.set(content, { display: 'block' });
				gsap.fromTo(
					content,
					{ height: 0 },
					{ height: 'auto', duration: 0.5 }
				);
				dropdown.classList.add('dropdowns__dropdown--active');
			}
		});
	});
}
dropdowns();
